import { Button, Dialog, DialogContent, makeStyles, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { useState } from 'react';
import Lottie from 'react-lottie-player';

import animationData from "src/pages/ActionLayout/Finalize/anim_completion.json";
import { useTrackEvent } from 'util/trackEvent';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      alignSelf: 'center',
      textAlign:'center',
      paddingBottom: theme.spacing(4),
      marginTop: theme.spacing(-3),
    },
    lottie: {
      height: 200
    },
    content: {
      lineHeight: '2em',
      padding: theme.spacing(3)
    }
  }
})
const BookingConfirmPopup = ({ booking_id, open = false }) => {
  const classes = useStyles()

  const [isOpen, setIsOpen] = useState(true);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const trackEvent = useTrackEvent()
  return (
    <Dialog open={isOpen} maxWidth="xs" >
      <Lottie
        className={classes.lottie}
        play
        loop={0}
        animationData={animationData}
      />
      <DialogContent className={classes.root}>
        <Typography variant='h4'>
          Your booking is not yet confirmed
        </Typography>
        <Typography variant='body1' className={classes.content}>
          Thank you for verifying the details. We will look for a provider to perform the service. <br /> We will notify you once your request has been matched and confirmed.
        </Typography>
        <Button variant='contained' size="large" color='primary' onClick={() => {
          trackEvent('Display Unmatched dialog - Okay', { dialog: 'BookingConfirmPopup' })
          setIsOpen(false)
        }}>Okay</Button>
      </DialogContent>
    </Dialog>
  )
}

export { BookingConfirmPopup };
